export enum CommunityActions {
  SendMessages = 'sendMessageForMembers',
  DownloadList = 'downloadAllMembers',
  RemoveMembers = 'removeMembersByEmail',
}
